import { HMIKeyType } from "./hmi.model";
import {
  IPredictionHistory,
  IPredictionResponse,
  IPredictionResult,
  IPredictiveParameters,
} from "./prediction.model";

export interface IRecommendationRequest {
  interval: number;
  target: number;
  target_value: number;
  predictive_parameters: IPredictiveParameters[];
}

export interface IRecommendationOutput {
  parameter: {
    id: number;
    name: HMIKeyType;
  };
  value: number;
}

export interface IRecommendationResponse extends IPredictionResponse {
  target: RecommendationParamEnum;
  target_value: number;
  output: IRecommendationOutput[];
}

export interface IRecommendationPayload {
  interval: number;
  target: keyof typeof RecommendationParamEnum;
  value: number;
}

export interface IRecommendationResultParameter {
  name: HMIKeyType;
  value: number;
}

export interface IRecommendationResult extends IPredictionResult {
  parameters?: IRecommendationResultParameter[];
}

export enum RecommendationParamEnum {
  carbon = 0,
  metallization = 1,
  productionRate = 2,
}

export interface IRecommendationRange {
  min: number;
  max: number;
}

export interface IRecommendationHistory extends IPredictionHistory {
  parameters: IRecommendationResultParameter[];
  targetParam: string;
  targetValue: number;
}
